var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasLoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.48 12.6337C17.91 8.55371 12.32 8.33371 13.67 2.40371C13.77 1.96371 13.3 1.62371 12.92 1.85371C9.29 3.99371 6.68 8.28371 8.87 13.9037C9.05 14.3637 8.51 14.7937 8.12 14.4937C6.31 13.1237 6.12 11.1537 6.28 9.74371C6.34 9.22371 5.66 8.97371 5.37 9.40371C4.69 10.4437 4 12.1237 4 14.6537C4.38 20.2537 9.11 21.9737 10.81 22.1937C13.24 22.5037 15.87 22.0537 17.76 20.3237C19.84 18.3937 20.6 15.3137 19.48 12.6337ZM10.2 17.6637C11.64 17.3137 12.38 16.2737 12.58 15.3537C12.91 13.9237 11.62 12.5237 12.49 10.2637C12.82 12.1337 15.76 13.3037 15.76 15.3437C15.84 17.8737 13.1 20.0437 10.2 17.6637Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasLoad);
export default __webpack_public_path__ + "static/media/gas-load.52b79fcb895512e4839b6e7e7ff05b41.svg";
export { ForwardRef as ReactComponent };